import React from 'react'

import { getErrorMessage } from 'utils'

import { useSnackbar } from 'contexts'
import {PaymentMethod} from 'services/billingApi'
import {useSetDefaultPaymentMethod} from 'hooks/api'

import { Stack, Typography } from '@mui/material'

import { Modal } from '@repo/ui'
import { Button } from '@repo/ui'
interface SetDefaultPaymentMethodModalProps {
  paymentMethod: PaymentMethod | null,
  open: boolean
  onClose: () => void
  refetch: () => Promise<unknown> | void
}

export const SetDefaultPaymentMethodModal = (props: SetDefaultPaymentMethodModalProps) => {
  const { paymentMethod, open, onClose = () => {}, refetch } = props
  const { open: notification } = useSnackbar()

  const setDefaultPaymentMethod = useSetDefaultPaymentMethod()

  const handleSetDefaultPaymentMethod = async () => {
    if (!paymentMethod) return

    try {
      await setDefaultPaymentMethod.mutateAsync(paymentMethod.id)
      handleClose()
      await Promise.resolve(refetch())
    } catch (error) {
      const message = getErrorMessage(error)
      notification({
        type: 'error',
        title: message,
      })
    }
  }

  const handleClose = () => {
    onClose()
  }


  return (
    <Modal
      title={`Set default payment method`}
      open={open}
      onClose={handleClose}
      actions={
        <>
          <Button
            disableElevation
            variant="secondary"
            onClick={() => handleClose()}
          >
            Cancel
          </Button>

          <Button
            variant="primary"
            disableElevation
            disabled={!paymentMethod || setDefaultPaymentMethod.isPending}
            onClick={() => handleSetDefaultPaymentMethod()}
          >
            Continue
          </Button>
        </>
      }
    >
      <Stack spacing={4}>
        <Typography variant="body2" color="text.secondary">
          {paymentMethod
            ? `Would you like to set "${paymentMethod.label || `${(paymentMethod.brand || 'Card').toUpperCase()} •••• ${paymentMethod.last4}`}" as the default payment method?`
            : 'Would you like to set this payment method as the default?'}
        </Typography>
      </Stack>
    </Modal>
  )
}
